export default __webpack_public_path__ + "media/images/map/leaflet/customIcons/map-marker-blue-001480895895a1788107df203c9dccb8.png";